import { all_routes } from "Router/all_routes";

export const getNotificationURL = (url) => {
  switch (url) {
    case "ApplyLeave":
      return `${all_routes.leave}${all_routes.leave_manangement}`;

    default:
      return "/Notification/AllNotification";
  }
};
